// guest-only.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStoreService, NavigationService } from '@app/shared/services';

/**
 * ログイン済（＋プロフィールあり）なら /tabs/home にリダイレクト。
 * 未ログイン or プロフィール未設定のみアクセス可。
 */
export const guestOnlyGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStoreService);
  const navigation = inject(NavigationService);

  const user = await authStore.waitForCurrentUser();
  console.log('############# users', user);

  if (user) {
    navigation.navigateToRoot('/tabs/home');
    return false;
  }
  return true;
};
